module.exports = __webpack_public_path__ + "img/top_left.9c9b2cd8.svg";